import { AlertTriangle, X } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-[#1a3e54]/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn">
      <div className="bg-white rounded-[2rem] p-8 max-w-sm w-full shadow-2xl animate-slideUp border border-[#1a3e54]/5 text-center">
        <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-[#9e142f]" />
        </div>
        
        <h2 className="text-2xl font-playfair font-bold text-[#1a3e54] mb-2 tracking-tight">
          {title || 'Delete Event'}
        </h2>
        
        <p className="text-[#1a3e54]/60 text-sm leading-relaxed mb-8">
          {message || 'This action cannot be undone. Are you sure you want to remove this moment?'}
        </p>
        
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-4 bg-gray-100 hover:bg-gray-200 text-[#1a3e54]/60 font-bold rounded-2xl transition-all"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-4 bg-[#9e142f] hover:bg-[#801026] text-white font-bold rounded-2xl transition-all shadow-lg shadow-red-900/10"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}